<template>
  <b-modal
    centered
    ref="modal-new"
    v-model="showModalNewConversation"
    title="Nova Conversa"
  >
    <b-form-group label="Selecione um Provedor" label-for="cmb-provider">
      <b-form-select
        id="mode-select"
        class="w-100"
        v-model="typeOption"
        required
      >
        <b-form-select-option
          v-for="option in types"
          :key="option.id"
          :value="option.type"
        >
          {{ option.name }}
        </b-form-select-option>
      </b-form-select>
      <div class="invalid-feedback">
        Por favor, forneça um número válido.
      </div>
    </b-form-group>
    <b-form-group
      label="Número para envio do Ativo"
      label-for="conversation-send"
    >
      <b-form-input
        id="conversation-send"
        v-model="numberProvider"
        disabled
      ></b-form-input>
    </b-form-group>
    <b-form-group label="Nome" label-for="conversation-person">
      <b-form-input
        id="conversation-person"
        v-model="newConversationPerson"
        disabled
      ></b-form-input>
    </b-form-group>
    <b-form-group label="Telefone" label-for="conversation-subject">
      <b-form-input
        id="conversation-subject"
        v-model="newConversationSubject"
        v-mask="['(##) ####-####', '(##) # ####-####']"
        required
        disabled
      ></b-form-input>
    </b-form-group>
    <b-form-group
      label="Parâmetro do HSM"
      label-for="conversation-hsm"
      v-if="typeOption === 'WHATS_META'"
    >
      <b-form-select
        id="conversation-hsm"
        @change="updateHsmText"
        v-model="selectedHsm"
        required
      >
        <b-form-select-option v-for="hsm in hsms" :key="hsm.id" :value="hsm.id">
          {{ hsm.hsmName }}
        </b-form-select-option>
      </b-form-select>
    </b-form-group>
    <div v-if="typeOption === 'WHATS_META'">
      <b-form-group
        v-for="(param, index) in templateParameters"
        :key="index"
        :label="'Parâmetro ' + param.name"
      >
        <b-form-input v-model="param.text" required></b-form-input>
      </b-form-group>
    </div>
    <b-form-group label="Mensagem" label-for="conversation-subject">
      <b-form-textarea
        id="conversation-subject"
        v-model="newConversationMessage"
        :disabled="typeOption === 'WHATS_META'"
        required
      ></b-form-textarea>
    </b-form-group>

    <template #modal-footer>
      <div class="w-100 text-right">
        <button
          type="button"
          class="btn btn-third btn-sm"
          @click="createConversation"
          v-b-tooltip.hover
          :title="'Criar'"
        >
          <i class="fas fa-check-circle"></i
          ><span class="d-md-down-none">Criar</span>
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'
import AccountMixin from '@/store/module/account/mixin'
import NumRepository from '@/shared/http/repositories/access/cadastroNum'
import HsmRepository from '@/shared/http/repositories/configurations/hsm'

export default {
  name: 'AssociateCreateNotProvider',
  data () {
    return {
      showModalNewConversation: false,
      newConversationPerson: '',
      newConversationSubject: '',
      newConversationMessage: '',
      originalMessage: '',
      types: [],
      typeOption: '',
      idProvider: 1,
      hsms: [],
      templateParameters: [],
      variables: [],
      hsmId: '',
      objectHsm: null,
      selectedHsm: '',
      numberProvider: '',
      identifierProvider: '',
      conversationInfo: null,
      selectedHsmObj: null
    }
  },
  mixins: [AccountMixin],
  props: {
  },
  created () {
    this.loadNumbers()
    this.loadHms()
  },
  watch: {
    typeOption (newVal) {
      const selectedType = this.types.find(type => type.type === newVal)
      if (selectedType) {
        this.numberProvider = selectedType.formattedNumber
        this.identifierProvider = selectedType.number
        this.newConversationMessage = ''
      }
    },
    templateParameters: {
      handler: 'updateMessage',
      deep: true
    }
  },
  methods: {
    async createConversation () {
      if (this.typeOption === 'WHATS_META') {
        this.isMeta()
      } else if (this.typeOption === 'WHATS_WPP') {
        this.isWPP()
      }
    },
    async isWPP () {
      const identifierFormat = this.newConversationSubject.replace(/\D/g, '')
      const requestConfig = {
        identifier: identifierFormat,
        operatorId: this.account.id,
        status: 'A',
        provider: this.typeOption.toLowerCase(),
        type: 'chat',
        message: {
          type: 'text',
          text: this.newConversationMessage
        },
        name: this.newConversationPerson,
        botId: 'NDA',
        identifierProvider: this.identifierProvider
      }
      try {
        await AtendimentoRepository.CreateConversation(requestConfig)
        this.clearFields()
        this.closeModal()
      } catch (error) {
        console.error(error)
      }
    },
    async isMeta () {
      const identifierFormat = this.newConversationSubject.replace(/\D/g, '')
      const components = []
      if (this.selectedHsmObj.hasImage) {
        const component = {
          type: 'header',
          parameters: [
            {
              type: 'image',
              image: {
                id: this.selectedHsmObj.hsmImageId
              }
            }
          ]
        }
        components.push(component)
      }
      components.push({
        type: 'body',
        parameters: this.templateParameters.map(param => ({
          name: param.name,
          type: param.type,
          text: param.text
        }))
      })
      const requestConfig = {
        identifier: identifierFormat,
        operatorId: this.account.id,
        status: 'A',
        provider: this.typeOption.toLowerCase(),
        type: 'template',
        message: {
          type: 'template',
          template: {
            name: this.hsmId,
            components
          }
        },
        name: this.newConversationPerson,
        botId: 'NDA',
        identifierProvider: this.identifierProvider
      }
      try {
        await AtendimentoRepository.CreateConversation(requestConfig)
        this.clearFields()
        this.closeModal()
      } catch (error) {
        console.error(error)
      }
    },
    replacePlaceholders (message) {
      return message
        .replace(/@Nome@/gi, this.newConversationPerson)
        .replace(/@Telefone@/gi, this.newConversationSubject)
        .replace(/@Email@/gi, this.conversationInfo.pessoa.email)
    },
    getValueParameters (parametro) {
      if (parametro.toLowerCase() === 'nome') {
        return this.newConversationPerson
      } else if (parametro.toLowerCase() === 'celular') {
        return this.newConversationSubject
      } else if (parametro.toLowerCase() === 'email') {
        if (this.conversationInfo) {
          return this.conversationInfo.pessoa.email
        } else {
          return ''
        }
      }
      return ''
    },
    capitalizeFirstLetter (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    async loadHms () {
      try {
        const response = await HsmRepository.GetAll()
        this.hsms = response.data.content
      } catch (error) {
        console.error('Erro ao carregar HSMs:', error)
      }
    },
    async loadNumbers () {
      try {
        const requestConfig = {
          params: {
            active: 1
          }
        }
        const response = await NumRepository.getEnvAll(requestConfig)
        this.types = response.data.content
      } catch (error) {
        console.error('Erro ao carregar números:', error)
      }
    },
    openModal (conversationInfo, telefone) {
      this.conversationInfo = conversationInfo
      if (this.conversationInfo && this.conversationInfo.pessoa) {
        this.newConversationPerson = this.conversationInfo.pessoa.nome
      }
      this.newConversationSubject = telefone
      this.showModalNewConversation = true
    },
    closeModal () {
      this.showModalNewConversation = false
    },
    clearFields () {
      this.newConversationPerson = ''
      this.newConversationSubject = ''
      this.newConversationMessage = ''
      this.originalMessage = ''
      this.typeOption = ''
      this.selectedHsm = ''
      this.numberProvider = ''
      this.identifierProvider = ''
    },
    updateHsmText () {
      const selectedHsmObj = this.hsms.find(hsm => hsm.id === this.selectedHsm)
      if (selectedHsmObj) {
        this.selectedHsmObj = selectedHsmObj
        this.newConversationMessage = selectedHsmObj.hsmText
        this.originalMessage = selectedHsmObj.hsmText
        this.variables = selectedHsmObj.variaveisHsmList
        this.templateParameters = this.variables.map(variable => ({
          name: variable,
          type: 'text',
          text: this.getValueParameters(variable)
        }))
        this.hsmId = selectedHsmObj.hsmId
      }
    },
    updateMessage () {
      let message = this.originalMessage
      this.templateParameters.forEach(param => {
        let regex = new RegExp(`@${param.name}@`, 'gi')
        message = message.replace(regex, param.text)
        if (param.name.toLowerCase() === 'celular') {
          regex = new RegExp('@Telefone@', 'gi')
          message = message.replace(regex, param.text)
        }
      })
      this.newConversationMessage = message
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/components/associateCreate.vue